import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { numberFormatter } from '../../components/formatters/numberFormatter';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import {  Table } from 'antd';
const ComponentToPrint = React.forwardRef((props, ref) => {
  const { journalVoucher, vatAmount, isUsingMainCurrency } = props;

  let cartColumns;

  const costTypes = ['PurchaseInvoice', 'PurchaseReturn', 'PurchaseOrder'];

  if (costTypes.includes(journalVoucher?.type)) {
    cartColumns = [
      { title: 'Product', dataIndex: 'product', render: (product) => (product?.name), width: '10%' },
      { title: 'Quantity', dataIndex: 'quantity', render: numberFormatter },
      { title: 'FreeQuantity', dataIndex: 'freeQuantity', render: numberFormatter },
      { title: 'NetQuantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'Cost', dataIndex: 'cost', render: numberFormatter },
      { title: 'Discount', dataIndex: 'costDiscountPercentage', render: numberFormatter },
      { title: 'NetCost', dataIndex: 'netCost', render: numberFormatter },
      { title: 'VAT', dataIndex: 'vatAmount', render: numberFormatter }, 
      Table.EXPAND_COLUMN,
    ];
  } else {
    cartColumns = [
      { title: 'Product', dataIndex: 'product', render: (product) => (product?.name), width: '10%' },
      { title: 'Unit', dataIndex: 'unitName', render: (unitName, record) => (unitName + ' (' + record.unitQuantity + ')') },
      { title: 'Price', dataIndex: 'price', render: numberFormatter },
      { title: 'Discount', dataIndex: 'costDiscountPercentage', render: numberFormatter },
      { title: 'NetQuantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'NetPrice', dataIndex: 'netPrice', render: numberFormatter },
      { title: 'Quantity', dataIndex: 'netQuantity', render: numberFormatter },
      { title: 'TotalPrice', dataIndex: 'totalPrice', render: numberFormatter },
      { title: 'VAT', dataIndex: 'vatAmount', render: numberFormatter },
      Table.EXPAND_COLUMN,
    ];
  }


  return (
    <div ref={ref} style={{ padding: '20px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
      {/* Header Section */}
      <div
        style={{
          textAlign: 'center',
          backgroundColor: '#23576a',
          color: 'white',
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '20px',
        }}
      >
        <h4 style={{ margin: 0 }}>{journalVoucher?.type || 'Invoice'}</h4>
      </div>

      {/* Info Section */}
      <div style={{ marginBottom: '20px', lineHeight: '1.8' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>
            <p><strong>Invoice ID:</strong> {journalVoucher?.id}</p>
            <p><strong>Account:</strong> {journalVoucher?.account?.english}</p>
            <p><strong>Ref#:</strong> {journalVoucher?.refNumber || '-'}</p>
            <p><strong>Branch:</strong> {journalVoucher?.branch?.name || '-'}</p>
            <p><strong>Currency:</strong> {journalVoucher?.currency?.code || '-'}</p>
          </div>
          <div>
            <p><strong>Created At:</strong> {dateTableFormatter(journalVoucher?.createdAt)}</p>
            <p><strong>Date:</strong> {journalVoucher?.date}</p>
            <p><strong>Warehouse:</strong> {journalVoucher?.warehouse?.name || '-'}</p>
            <p><strong>Project:</strong> {journalVoucher?.project?.name || '-'}</p>
            <p><strong>Rate:</strong> {journalVoucher?.currency?.rate || '-'}</p>
          </div>
        </div>
      </div>

      <div ref={ref} style={{ padding: '20px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
      {/* Table Section */}
      {journalVoucher?.cart?.length > 0 && (
        <Table
          columns={cartColumns}
          dataSource={journalVoucher?.cart}
          pagination={false}
          expandable={{
            expandedRowRender: (record) => (
              <p style={{ margin: 0, color: '#119FE2' }}>{record.details}</p>
            ),
            rowExpandable: (record) => !!record.details, // Only allow rows with details to be expandable
          }}
        />
      )}
    </div>

      {/* Totals Section */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px', fontSize: '16px' }}>
        <div style={{ textAlign: 'right' }}>
          <p><strong>Discount:</strong> {numberFormatter(journalVoucher?.discountPercentage)}%</p>
          <p><strong>VAT:</strong> {numberFormatter(vatAmount)}</p>
          <p><strong>Total:</strong> {numberFormatter(isUsingMainCurrency ? journalVoucher?.totalDebit : journalVoucher?.secondaryTotalDebit)}  {journalVoucher?.transactions[0]?.currency.symbol} </p>
        </div>
      </div>
    </div>
  );
});

export default ComponentToPrint;